import React from "react";

const AboutUs = () => {
  return (
    <div className="terms-and-condition container mt-5">
      <h1>About Us</h1>
      <div className="mt-3 mb-5">
        <p>
          Welcome to <b>Rolidex App</b>, the ultimate solution for modern
          networking. Our mission is to revolutionize how professionals connect,
          exchange information, and manage their business contacts.
        </p>
        <br />
        <p>
          We believe that traditional business cards are outdated, inefficient,
          and environmentally unsustainable. That’s why we’ve developed an{" "}
          <b>AI-powered digital business card solution</b> that helps you{" "}
          <b>scan, store, organize, and share</b> contacts effortlessly. Whether
          you're an entrepreneur, corporate executive, or freelancer, our
          platform enables you to build{" "}
          <b>meaningful professional relationships with ease.</b>
        </p>
        <br />
        <p>
          With advanced{" "}
          <b>
            QR code sharing, seamless contact organization, and cloud backup
          </b>
          , we make networking <b>smarter, faster, and more secure</b>. Join
          thousands of professionals using our platform to enhance their
          networking experience.
        </p>
        <br />
        <p>
          Let’s <b>connect, grow, and succeed—digitally!</b>
        </p>
        <br />
      </div>
    </div>
  );
};

export default AboutUs;
